import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dd76fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-block" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500 ml-auto flex place-items-center"
}
const _hoisted_3 = { class: "inline-block relative w-full" }
const _hoisted_4 = { class: "flex gap-1 flex-1 items-center max-w-full" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex gap-2 items-center" }

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Selector',
  props: {
  model: {
    type: [Array, String],
    required: true,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array,
    required: true,
  },
  icons: {
    type: Array,
    required: false,
  },
  values: {
    type: Array,
    required: false,
  },
  nullAlowed: {
    type: Boolean,
    default: false,
  },
  iconName: {
    type: String,
    required: false,
  },
  multiPlaceholder: {
    type: String,
    required: false,
    default: "Estados",
  },
  label: {
    type: String,
    required: false,
  },

  onTop: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ["update:model"],
  setup(__props, { emit }) {

const props = __props;





const isActive = ref(false);

const placeholder = computed(() => {
  if (__isMultiselection.value)
    return props.model.length > 0
      ? `${props.model.length} ${props.multiPlaceholder}`
      : "";
  else {
    if (props.values) {
      const index = props.values.indexOf(props.model);
      return props.items[index];
    }
    return props.model;
  }
});

const __isMultiselection = computed(() => props.model instanceof Array);

function __getRealItem(item: string): any {
  return props.values ? props.values[props.items.indexOf(item)] : item;
}

function __isSelected(item: string): boolean {
  if (__isMultiselection.value) return props.model.includes(item);
  return props.model == item;
}

function __unselect(item: string) {
  if (__isMultiselection.value) {
    const index = props.model.indexOf(item, 0);
    if (index > -1) {
      const newModel = [...props.model];
      newModel.splice(index, 1);
      emit("update:model", newModel);
    }
  } else if (props.nullAlowed) {
    emit("update:model", "");
  }
}

function __select(item: string) {
  if (__isMultiselection.value) {
    const newModel = [...props.model];
    newModel.push(item);
    emit("update:model", newModel);
  } else {
    emit("update:model", item);
  }
}

function getItemExtraClass(item: string): string {
  const realItem = __getRealItem(item);
  if (__isSelected(realItem)) {
    return "text-primary-400 font-bold bg-primary-50";
  }
  return "";
}

function switchSelection(item: string) {
  const realItem: any = __getRealItem(item);
  if (__isSelected(realItem)) __unselect(realItem);
  else __select(realItem);

  // Ocultando menu si es que es seleccion simple
  if (!__isMultiselection.value) isActive.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["flex text-sm font-semibold pb-1", { 'text-red-500': __props.hasError, 'text-gray-700': !__props.hasError }])
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Popper, {
                  arrow: "",
                  class: "font-normal",
                  placement: "auto",
                  hover: "",
                  content: __props.errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mdicon, {
                      name: "error",
                      size: "16"
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = !isActive.value)),
        class: _normalizeClass(["appearance-none border rounded-sm w-full py-1 px-2 leading-tight focus:outline-none cursor-pointer flex items-center h-[38px] relative select-none bg-white", {
          'text-gray-700 border-gray-300 focus:border-black hover:border-gray-400':
            !__props.hasError,
          'text-red-700 border-red-300 focus:border-red-800 hover:border-red-400':
            __props.hasError,
        }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          (__props.iconName)
            ? (_openBlock(), _createBlock(_component_mdicon, {
                key: 0,
                name: __props.iconName,
                size: "20"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(placeholder.value), 1)
        ]),
        _createVNode(_component_mdicon, {
          class: "absolute right-2 bg-white",
          name: "chevron-down",
          size: "20"
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{
          block: isActive.value,
          hidden: !isActive.value,
          'bottom-9 rounded-t-lg': __props.onTop,
          'rounded-b-lg': !__props.onTop,
        }, "absolute text-gray-700 bg-white left-0 w-full min-w-max border-gray-200 border-[0.5px] shadow-lg overflow-y-auto max-h-36 z-50 select-none"])
      }, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              class: _normalizeClass([getItemExtraClass(item as string), "hover:bg-primary-50 active:bg-primary-100 py-2 px-4 block whitespace-no-wrap cursor-pointer"]),
              onClick: ($event: any) => (switchSelection(item as string))
            }, [
              _createElementVNode("div", _hoisted_7, [
                (__props.icons)
                  ? (_openBlock(), _createBlock(_component_mdicon, {
                      key: 0,
                      name: __props.icons[key],
                      size: "20"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item), 1)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ])
      ], 2)
    ])), [
      [_directive_click_outside, () => (isActive.value = false)]
    ])
  ]))
}
}

})